import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import {
	ENABLED_HEAD_MENU_ITEMS,
	HEAD_MENU_ITEMS,
	HeadMenuItems,
} from './HeadMenu.model';
import {
	StyledButtonContent,
	StyledContainer,
	StyledLeftContainer,
} from './HeadMenu.styled';

interface IHeadMenuProps {
	active: HeadMenuItems;
	onSelect: (item: HeadMenuItems) => void;
}

const HeadMenu = ({ active, onSelect }: IHeadMenuProps) => {
	return (
		<StyledContainer>
			<StyledLeftContainer>
				{Object.values(HeadMenuItems).map((item) => {
					const isEnabled = ENABLED_HEAD_MENU_ITEMS.includes(item);
					const isActive = active === item;

					return (
						<Button
							key={item}
							color={isActive ? ButtonColors.Select : ButtonColors.Default}
							height={ButtonHeight.Height40}
							borderRadius={ButtonBorderRadius.Radius5}
							disabled={!isEnabled}
							onClick={() => onSelect(item)}
						>
							<StyledButtonContent>
								<Text>{HEAD_MENU_ITEMS[item]}</Text>
							</StyledButtonContent>
						</Button>
					);
				})}
			</StyledLeftContainer>
		</StyledContainer>
	);
};

export { HeadMenu };
